import { Divider, Grid } from "@mui/material";
import * as React from "react";
import CardHESP from "../../CardHESP/CardHESP";
import { GetChannelQuery_channel } from "../Overview/__generated__/GetChannelQuery";
import DeleteChannelDialog from "../Overview/DeleteChannelDialog";
import { navigate } from "@reach/router";
import { DeleteForeverOutlined } from "@mui/icons-material";

interface Props {
    channel: GetChannelQuery_channel;
}

export default function ChannelDangerZone({ channel }: Props) {
    const [openDeleteDialog, setOpenDeleteDialog] = React.useState<boolean>(false);

    return (
        <>
            <CardHESP>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <div className="font-bold text-sm">Danger zone</div>
                        <Divider />
                        <div className="h-2"></div>
                        <div className="flex flex-row w-full justify-between gap-2 text-sm">
                            <div>
                                <div className="text-[13px] font-semibold">Delete channel</div>
                                <div className="text-xs text-gray-400">
                                    Remove channel completely. This action is irreversible!
                                </div>
                            </div>
                            <div>
                                <button
                                    className=" bg-red-500 hover:bg-red-400 rounded-md text-white font-semibold text-xs px-4 py-2 gap-2 flex items-center"
                                    onClick={() => setOpenDeleteDialog(true)}
                                >
                                    <DeleteForeverOutlined style={{ fontSize: "16px" }} />
                                    Delete
                                </button>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </CardHESP>
            <DeleteChannelDialog
                channel={{
                    channelId: channel.channelId,
                    name: channel.metadata.name,
                    organizationId: channel.organizationId,
                }}
                open={openDeleteDialog}
                onDone={() => {
                    setOpenDeleteDialog(false);
                    navigate(`/app/${channel.organizationId}/channels`);
                }}
                onClose={() => setOpenDeleteDialog(false)}
            />
        </>
    );
}
